import styled from 'styled-components';
import ChevronDown from 'icons/src/ChevronDown';

export default styled(ChevronDown)`
  width: .75rem;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 1rem;
  pointer-events: none;
`;
